import * as React from "react"

// Custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/cormorant-garamond/400.css"
import "@fontsource/cormorant-garamond/400-italic.css"
// Normalize CSS across browsers
import "./src/normalize.css"
// Custom CSS styles
import "./src/style.css"
import Header from "./src/components/header"

// Highlighting for code blocks
import "prismjs/themes/prism-tomorrow.css"

export const onRouteUpdate = () => {
  requestAnimationFrame(() => window.scrollTo(0, 0))
}

export const wrapRootElement = ({ element }) => {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary">
      <Header />
      <main>{element}</main>
    </div>
  )
}
